import React from "react";
import PropTypes from "prop-types";
import { CModal, CModalHeader, CModalTitle, CModalBody } from "@coreui/react";

const PhotoModal = ({ visible, url, title, onClose }) => {
  return (
    <CModal alignment="center" size="xl" visible={visible} onClose={onClose}>
      <CModalHeader closeButton className="bg-light">
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody className="p-0 text-center bg-black">
        {url && (
          <img
            src={url}
            alt="Full Proof"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        )}
      </CModalBody>
    </CModal>
  );
};

PhotoModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PhotoModal;